import React from 'react';
import './login.css';
import SolutionArtImage from '../Image/sart-logo.png'

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <div className='Footer'>
        <p>© {currentYear} All Rights Reserved by Bangladesh Coast Guard</p>
        <p>Crafted by Solution Art  <img src={SolutionArtImage} alt = 'Solution Art'/></p>
       
    </div>
  );
}

export default Footer;
